module.exports = __webpack_public_path__ + "static/img/spa.2e8059c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/spa.png
// module id = KH40
// module chunks = 0